const LiveStreamingData = () =>
  import('@/views/main/thirdPartyLive/liveStreamingData/LiveStreamingData.vue')
export default {
  path: '/main/thirdPartyLive/liveStreamingData',
  name: 'LiveStreamingData',
  component: LiveStreamingData
}
